import { UseFormRegister, FieldError } from 'react-hook-form'
import { ContactFormValues } from '@utils'
import { ContactMessage } from '@types'
import FormField from './formField'

interface TextFieldProps {
    message: ContactMessage
    register: UseFormRegister<ContactFormValues>
    error?: FieldError
    isRequired?: boolean
}

const TextField = ({
    message,
    register,
    error,
    isRequired,
}: TextFieldProps) => {
    const fieldId = `contact-${message.title}`
    const fieldName = message.title as keyof ContactFormValues

    return (
        <FormField
            fieldId={fieldId}
            label={message.content}
            infoText={message.infoText}
            error={error?.message}
            required={isRequired}
        >
            <div className="flex w-fit ml-auto my-2">
                <div style={{ display: 'inline-block' }}>
                    <div
                        style={{
                            height: '0',
                            marginLeft: '2.6rem',
                            visibility: 'hidden',
                        }}
                    >
                        {message.field}
                    </div>
                    <input
                        id={fieldId}
                        className="border-2 border-secondary-300 rounded py-2 pl-2"
                        style={{
                            display: 'inline',
                            width: '100%',
                            backgroundColor: '#F7F7F8',
                        }}
                        placeholder={message.field}
                        aria-required={isRequired || undefined}
                        aria-invalid={error ? true : undefined}
                        aria-describedby={
                            error ? `${fieldId}-error` : undefined
                        }
                        {...register(fieldName)}
                    />
                </div>
            </div>
        </FormField>
    )
}

export default TextField
